import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { BAlert, BButton, BCard, BForm, BFormGroup, BFormInput } from "bootstrap-vue";
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChangePassword',
    props: {
        token: null,
        expiredUser: null,
        messageText: null,
        messageVariant: null
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const confirm = ref(null);
        const current = ref(null);
        const password = ref(null);
        const message = ref(props.messageText);
        const variant = ref(props.messageVariant);
        async function submit() {
            try {
                await axios.post(withPrefix("/user/change_password"), {
                    token: props.token,
                    id: props.expiredUser,
                    current: current.value,
                    password: password.value,
                    confirm: confirm.value,
                });
                router.push("/");
            }
            catch (error) {
                variant.value = "danger";
                message.value = errorMessageAsString(error, "Password change failed for an unknown reason.");
            }
        }
        return { __sfc: true, props, router, confirm, current, password, message, variant, submit, BAlert, BButton, BCard, BForm, BFormGroup, BFormInput };
    }
});
